














































import { Component } from 'vue-mixin-decorator';
import BaseView from '@/views/BaseView.vue';
import ExamFooter from '@/components/ExamFooter.vue';
import ExamGuide from '@/components/ExamGuide.vue';
import ExamNav from '@/components/ExamNav.vue';
import ConfirmModal from '@/components/ConfirmModal.vue';
import * as JwtUtil from '@/common/JwtUtil';

import * as RouterPath from '@/classification/RouterPath';

@Component(
  {
    components: {
      'e-footer': ExamFooter,
      'e-guide': ExamGuide,
      'e-nav': ExamNav,
      'e-confirm-modal': ConfirmModal,
    },
  },
)
export default class Delete extends BaseView {
  private displayConfirmModal = false;

  private modalTitle = '本当に削除してよろしいですか？';

  private modalText = '一度削除するともとに戻すことはできません';

  private okButtonLabel = 'アカウントを削除する';

  private cancelButtonLabel = 'キャンセル';

  private mounted() {
    this.checkLogin();
    const CommonCss = document.createElement('link');
    CommonCss.rel = 'stylesheet';
    CommonCss.href = '/css/common.css';
    this.$el.appendChild(CommonCss);

    const AccountCommonCss = document.createElement('link');
    AccountCommonCss.rel = 'stylesheet';
    AccountCommonCss.href = '/account/css/common.css';
    this.$el.appendChild(AccountCommonCss);

    this.getExamConfigCss().then((cssElement: HTMLLinkElement) => {
      this.$el.appendChild(cssElement);
    });

    const CommonJs = document.createElement('script');
    CommonJs.src = '/js/common.js';
    this.$el.appendChild(CommonJs);
  }

  async checkLogin() {
    const jwt = JwtUtil.getJwtInfo();
    if (jwt == null) {
      // 未ログインの場合、ログイン/仮登録画面へ
      sessionStorage.setItem(JwtUtil.SESSION_RETURN_PATH_KEY, RouterPath.DELETE);
      this.$router.replace({ path: this.paths.LOGIN });
    }
  }

  private showConfirmModal() {
    this.checkLogin();
    this.displayConfirmModal = true;
  }

  private modalOkButtonClick() {
    const jwt = JwtUtil.getJwtInfo();
    if (jwt == null) {
      // 未ログインの場合、ログイン/仮登録画面へ
      sessionStorage.setItem(JwtUtil.SESSION_RETURN_PATH_KEY, RouterPath.DELETE_CONFIRM);
      this.$router.replace({ path: this.paths.LOGIN });
    } else {
      this.$router.replace(RouterPath.DELETE_CONFIRM);
    }
  }

  private modalCancelButtonClick() {
    this.displayConfirmModal = false;
  }
}
